import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { useRtl as Be } from "../../_mixins/use-rtl.js";
import Me from "./styles/input-number.cssr.js";
import { parseNumber as H, validator as L, format as X, isWipValue as Ne, parse as Te } from "./utils.js";
import Pe from "../../_mixins/use-config.js";
import ne from "../../_mixins/use-theme.js";
import Se from "../../_mixins/use-locale.js";
import Oe from "../../_mixins/use-form-item.js";
import De from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-merged-state.js";
import h from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-memo.js";
import { rgba as Ce } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/color/index.js";
import Fe from "../../input/src/Input.js";
import { resolveWrappedSlot as q, resolveSlot as J } from "../../_utils/vue/resolve-slot.js";
import { warnOnce as Ae } from "../../_utils/naive/warn.js";
import Ue from "../styles/light.js";
import { on as Q } from "../../../../../../evtd@0.2.4/node_modules/evtd/es/delegate.js";
import Y from "../../_internal/icon/src/Icon.js";
import _e from "../../_internal/icons/Remove.js";
import { XButton as Z } from "../../button/src/Button.js";
import Ee from "../../_internal/icons/Add.js";
import { call as I } from "../../_utils/vue/call.js";
import { defineComponent as ke, watchEffect as $e, watch as He, computed as Le, h as d, nextTick as je } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as B, toRef as ze } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const ee = 800, te = 100, Ge = Object.assign(Object.assign({}, ne.props), {
  autofocus: Boolean,
  loading: {
    type: Boolean,
    default: void 0
  },
  placeholder: String,
  defaultValue: {
    type: Number,
    default: null
  },
  value: Number,
  step: {
    type: [Number, String],
    default: 1
  },
  min: [Number, String],
  max: [Number, String],
  size: String,
  disabled: {
    type: Boolean,
    default: void 0
  },
  validator: Function,
  bordered: {
    type: Boolean,
    default: void 0
  },
  showButton: {
    type: Boolean,
    default: !0
  },
  buttonPlacement: {
    type: String,
    default: "right"
  },
  inputProps: Object,
  readonly: Boolean,
  clearable: Boolean,
  keyboard: {
    type: Object,
    default: {}
  },
  updateValueOnInput: {
    type: Boolean,
    default: !0
  },
  round: {
    type: Boolean,
    default: void 0
  },
  parse: Function,
  format: Function,
  precision: Number,
  status: String,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onFocus: [Function, Array],
  onBlur: [Function, Array],
  onClear: [Function, Array],
  // deprecated
  onChange: [Function, Array]
}), pt = ke({
  name: "InputNumber",
  props: Ge,
  slots: Object,
  setup(n) {
    process.env.NODE_ENV !== "production" && $e(() => {
      n.onChange !== void 0 && Ae("input-number", "`on-change` is deprecated, please use `on-update:value` instead");
    });
    const {
      mergedBorderedRef: i,
      mergedClsPrefixRef: g,
      mergedRtlRef: S
    } = Pe(n), u = ne("InputNumber", "-input-number", Me, Ue, n, g), {
      localeRef: v
    } = Se("InputNumber"), M = Oe(n), {
      mergedSizeRef: re,
      mergedDisabledRef: le,
      mergedStatusRef: ie
    } = M, s = B(null), j = B(null), z = B(null), O = B(n.defaultValue), ue = ze(n, "value"), f = De(ue, O), p = B(""), D = (e) => {
      const t = String(e).split(".")[1];
      return t ? t.length : 0;
    }, oe = (e) => {
      const t = [n.min, n.max, n.step, e].map((r) => r === void 0 ? 0 : D(r));
      return Math.max(...t);
    }, ae = h(() => {
      const {
        placeholder: e
      } = n;
      return e !== void 0 ? e : v.value.placeholder;
    }), N = h(() => {
      const e = H(n.step);
      return e !== null ? e === 0 ? 1 : Math.abs(e) : 1;
    }), G = h(() => {
      const e = H(n.min);
      return e !== null ? e : null;
    }), K = h(() => {
      const e = H(n.max);
      return e !== null ? e : null;
    }), b = () => {
      const {
        value: e
      } = f;
      if (L(e)) {
        const {
          format: t,
          precision: r
        } = n;
        t ? p.value = t(e) : e === null || r === void 0 || D(e) > r ? p.value = X(e, void 0) : p.value = X(e, r);
      } else
        p.value = String(e);
    };
    b();
    const V = (e) => {
      const {
        value: t
      } = f;
      if (e === t) {
        b();
        return;
      }
      const {
        "onUpdate:value": r,
        onUpdateValue: l,
        onChange: a
      } = n, {
        nTriggerFormInput: c,
        nTriggerFormChange: x
      } = M;
      a && I(a, e), l && I(l, e), r && I(r, e), O.value = e, c(), x();
    }, o = ({
      offset: e,
      doUpdateIfValid: t,
      fixPrecision: r,
      isInputing: l
    }) => {
      const {
        value: a
      } = p;
      if (l && Ne(a))
        return !1;
      const c = (n.parse || Te)(a);
      if (c === null)
        return t && V(null), null;
      if (L(c)) {
        const x = D(c), {
          precision: R
        } = n;
        if (R !== void 0 && R < x && !r)
          return !1;
        let m = Number.parseFloat((c + e).toFixed(R != null ? R : oe(c)));
        if (L(m)) {
          const {
            value: k
          } = K, {
            value: $
          } = G;
          if (k !== null && m > k) {
            if (!t || l)
              return !1;
            m = k;
          }
          if ($ !== null && m < $) {
            if (!t || l)
              return !1;
            m = $;
          }
          return n.validator && !n.validator(m) ? !1 : (t && V(m), m);
        }
      }
      return !1;
    }, de = h(() => o({
      offset: 0,
      doUpdateIfValid: !1,
      isInputing: !1,
      fixPrecision: !1
    }) === !1), C = h(() => {
      const {
        value: e
      } = f;
      if (n.validator && e === null)
        return !1;
      const {
        value: t
      } = N;
      return o({
        offset: -t,
        doUpdateIfValid: !1,
        isInputing: !1,
        fixPrecision: !1
      }) !== !1;
    }), F = h(() => {
      const {
        value: e
      } = f;
      if (n.validator && e === null)
        return !1;
      const {
        value: t
      } = N;
      return o({
        offset: +t,
        doUpdateIfValid: !1,
        isInputing: !1,
        fixPrecision: !1
      }) !== !1;
    });
    function se(e) {
      const {
        onFocus: t
      } = n, {
        nTriggerFormFocus: r
      } = M;
      t && I(t, e), r();
    }
    function fe(e) {
      var t, r;
      if (e.target === ((t = s.value) === null || t === void 0 ? void 0 : t.wrapperElRef))
        return;
      const l = o({
        offset: 0,
        doUpdateIfValid: !0,
        isInputing: !1,
        fixPrecision: !0
      });
      if (l !== !1) {
        const x = (r = s.value) === null || r === void 0 ? void 0 : r.inputElRef;
        x && (x.value = String(l || "")), f.value === l && b();
      } else
        b();
      const {
        onBlur: a
      } = n, {
        nTriggerFormBlur: c
      } = M;
      a && I(a, e), c(), je(() => {
        b();
      });
    }
    function ce(e) {
      const {
        onClear: t
      } = n;
      t && I(t, e);
    }
    function A() {
      const {
        value: e
      } = F;
      if (!e) {
        E();
        return;
      }
      const {
        value: t
      } = f;
      if (t === null)
        n.validator || V(W());
      else {
        const {
          value: r
        } = N;
        o({
          offset: r,
          doUpdateIfValid: !0,
          isInputing: !1,
          fixPrecision: !0
        });
      }
    }
    function U() {
      const {
        value: e
      } = C;
      if (!e) {
        _();
        return;
      }
      const {
        value: t
      } = f;
      if (t === null)
        n.validator || V(W());
      else {
        const {
          value: r
        } = N;
        o({
          offset: -r,
          doUpdateIfValid: !0,
          isInputing: !1,
          fixPrecision: !0
        });
      }
    }
    const me = se, ve = fe;
    function W() {
      if (n.validator)
        return null;
      const {
        value: e
      } = G, {
        value: t
      } = K;
      return e !== null ? Math.max(0, e) : t !== null ? Math.min(0, t) : 0;
    }
    function pe(e) {
      ce(e), V(null);
    }
    function he(e) {
      var t, r, l;
      !((t = z.value) === null || t === void 0) && t.$el.contains(e.target) && e.preventDefault(), !((r = j.value) === null || r === void 0) && r.$el.contains(e.target) && e.preventDefault(), (l = s.value) === null || l === void 0 || l.activate();
    }
    let w = null, y = null, T = null;
    function _() {
      T && (window.clearTimeout(T), T = null), w && (window.clearInterval(w), w = null);
    }
    let P = null;
    function E() {
      P && (window.clearTimeout(P), P = null), y && (window.clearInterval(y), y = null);
    }
    function ge() {
      _(), T = window.setTimeout(() => {
        w = window.setInterval(() => {
          U();
        }, te);
      }, ee), Q("mouseup", document, _, {
        once: !0
      });
    }
    function be() {
      E(), P = window.setTimeout(() => {
        y = window.setInterval(() => {
          A();
        }, te);
      }, ee), Q("mouseup", document, E, {
        once: !0
      });
    }
    const xe = () => {
      y || A();
    }, Ie = () => {
      w || U();
    };
    function Ve(e) {
      var t, r;
      if (e.key === "Enter") {
        if (e.target === ((t = s.value) === null || t === void 0 ? void 0 : t.wrapperElRef))
          return;
        o({
          offset: 0,
          doUpdateIfValid: !0,
          isInputing: !1,
          fixPrecision: !0
        }) !== !1 && ((r = s.value) === null || r === void 0 || r.deactivate());
      } else if (e.key === "ArrowUp") {
        if (!F.value || n.keyboard.ArrowUp === !1)
          return;
        e.preventDefault(), o({
          offset: 0,
          doUpdateIfValid: !0,
          isInputing: !1,
          fixPrecision: !0
        }) !== !1 && A();
      } else if (e.key === "ArrowDown") {
        if (!C.value || n.keyboard.ArrowDown === !1)
          return;
        e.preventDefault(), o({
          offset: 0,
          doUpdateIfValid: !0,
          isInputing: !1,
          fixPrecision: !0
        }) !== !1 && U();
      }
    }
    function we(e) {
      p.value = e, n.updateValueOnInput && !n.format && !n.parse && n.precision === void 0 && o({
        offset: 0,
        doUpdateIfValid: !0,
        isInputing: !0,
        fixPrecision: !1
      });
    }
    He(f, () => {
      b();
    });
    const ye = {
      focus: () => {
        var e;
        return (e = s.value) === null || e === void 0 ? void 0 : e.focus();
      },
      blur: () => {
        var e;
        return (e = s.value) === null || e === void 0 ? void 0 : e.blur();
      },
      select: () => {
        var e;
        return (e = s.value) === null || e === void 0 ? void 0 : e.select();
      }
    }, Re = Be("InputNumber", S, g);
    return Object.assign(Object.assign({}, ye), {
      rtlEnabled: Re,
      inputInstRef: s,
      minusButtonInstRef: j,
      addButtonInstRef: z,
      mergedClsPrefix: g,
      mergedBordered: i,
      uncontrolledValue: O,
      mergedValue: f,
      mergedPlaceholder: ae,
      displayedValueInvalid: de,
      mergedSize: re,
      mergedDisabled: le,
      displayedValue: p,
      addable: F,
      minusable: C,
      mergedStatus: ie,
      handleFocus: me,
      handleBlur: ve,
      handleClear: pe,
      handleMouseDown: he,
      handleAddClick: xe,
      handleMinusClick: Ie,
      handleAddMousedown: be,
      handleMinusMousedown: ge,
      handleKeyDown: Ve,
      handleUpdateDisplayedValue: we,
      // theme
      mergedTheme: u,
      inputThemeOverrides: {
        paddingSmall: "0 8px 0 10px",
        paddingMedium: "0 8px 0 12px",
        paddingLarge: "0 8px 0 14px"
      },
      buttonThemeOverrides: Le(() => {
        const {
          self: {
            iconColorDisabled: e
          }
        } = u.value, [t, r, l, a] = Ce(e);
        return {
          textColorTextDisabled: `rgb(${t}, ${r}, ${l})`,
          opacityDisabled: `${a}`
        };
      })
    });
  },
  render() {
    const {
      mergedClsPrefix: n,
      $slots: i
    } = this, g = () => d(Z, {
      text: !0,
      disabled: !this.minusable || this.mergedDisabled || this.readonly,
      focusable: !1,
      theme: this.mergedTheme.peers.Button,
      themeOverrides: this.mergedTheme.peerOverrides.Button,
      builtinThemeOverrides: this.buttonThemeOverrides,
      onClick: this.handleMinusClick,
      onMousedown: this.handleMinusMousedown,
      ref: "minusButtonInstRef"
    }, {
      icon: () => J(i["minus-icon"], () => [d(Y, {
        clsPrefix: n
      }, {
        default: () => d(_e, null)
      })])
    }), S = () => d(Z, {
      text: !0,
      disabled: !this.addable || this.mergedDisabled || this.readonly,
      focusable: !1,
      theme: this.mergedTheme.peers.Button,
      themeOverrides: this.mergedTheme.peerOverrides.Button,
      builtinThemeOverrides: this.buttonThemeOverrides,
      onClick: this.handleAddClick,
      onMousedown: this.handleAddMousedown,
      ref: "addButtonInstRef"
    }, {
      icon: () => J(i["add-icon"], () => [d(Y, {
        clsPrefix: n
      }, {
        default: () => d(Ee, null)
      })])
    });
    return d("div", {
      class: [`${n}-input-number`, this.rtlEnabled && `${n}-input-number--rtl`]
    }, d(Fe, {
      ref: "inputInstRef",
      autofocus: this.autofocus,
      status: this.mergedStatus,
      bordered: this.mergedBordered,
      loading: this.loading,
      value: this.displayedValue,
      onUpdateValue: this.handleUpdateDisplayedValue,
      theme: this.mergedTheme.peers.Input,
      themeOverrides: this.mergedTheme.peerOverrides.Input,
      builtinThemeOverrides: this.inputThemeOverrides,
      size: this.mergedSize,
      placeholder: this.mergedPlaceholder,
      disabled: this.mergedDisabled,
      readonly: this.readonly,
      round: this.round,
      textDecoration: this.displayedValueInvalid ? "line-through" : void 0,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onKeydown: this.handleKeyDown,
      onMousedown: this.handleMouseDown,
      onClear: this.handleClear,
      clearable: this.clearable,
      inputProps: this.inputProps,
      internalLoadingBeforeSuffix: !0
    }, {
      prefix: () => {
        var u;
        return this.showButton && this.buttonPlacement === "both" ? [g(), q(i.prefix, (v) => v ? d("span", {
          class: `${n}-input-number-prefix`
        }, v) : null)] : (u = i.prefix) === null || u === void 0 ? void 0 : u.call(i);
      },
      suffix: () => {
        var u;
        return this.showButton ? [q(i.suffix, (v) => v ? d("span", {
          class: `${n}-input-number-suffix`
        }, v) : null), this.buttonPlacement === "right" ? g() : null, S()] : (u = i.suffix) === null || u === void 0 ? void 0 : u.call(i);
      }
    }));
  }
});
export {
  pt as default,
  Ge as inputNumberProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/input-number/src/InputNumber.js
// module id = 153
// module chunks = 67